import { render, staticRenderFns } from "./GithubLogin.vue?vue&type=template&id=1e0490a3&scoped=true"
import script from "./GithubLogin.vue?vue&type=script&lang=js"
export * from "./GithubLogin.vue?vue&type=script&lang=js"
import style0 from "./GithubLogin.vue?vue&type=style&index=0&id=1e0490a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0490a3",
  null
  
)

export default component.exports